import { a as TailwindElement, x } from '../../index-e3189942.js';
import { e, a as e$1 } from '../../directive-9ec64c08.js';
import { o } from '../../style-map-e2dd0466.js';
import { c as customClassMap } from '../../index-714323c9.js';

const sliceAddress = (address, startSliceBy = 6, endSliceBy) => {
  if (!address) {
    return "";
  }
  let sliceAddress2 = "";
  endSliceBy = endSliceBy || startSliceBy;
  if (address.length < startSliceBy + endSliceBy) {
    return address;
  }
  sliceAddress2 = address.length > startSliceBy + 2 ? `${address.slice(0, startSliceBy + 2)}...${address.slice(-endSliceBy)}` : address;
  return sliceAddress2;
};

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
let LuksoUsername = class extends TailwindElement {
  constructor() {
    super(...arguments);
    this.name = "";
    this.address = "";
    this.maxWidth = 200;
    this.size = "large";
    this.sliceBy = 8;
    this.addressColor = "neutral-20";
    /** Width of the first 4 bytes of the address */
    this.bytesWidth = 52;
  }
  /**
   * Template for 4byte address
   * e.g: #1234
   */
  addressBytesTemplate() {
    return x`<div class="inline-block text-neutral-60">
      #${this.address.slice(2, 6)}
    </div>`;
  }
  /**
   * Template for name
   * e.g: @John
   */
  nameTemplate() {
    return x`<div
      class="inline-block whitespace-nowrap overflow-hidden text-ellipsis text-transparent
      bg-clip-text bg-gradient-to-r from-gradient-1-start to-gradient-1-end"
      style=${o({
      maxWidth: `${this.maxWidth - this.bytesWidth}px`
    })}
    >
      @${this.name}
    </div>`;
  }
  /**
   * Template for address
   * e.g: 0x123...789
   */
  addressTemplate() {
    return x`<div
      class="inline-block ${customClassMap({
      ["text-" + this.addressColor]: this.addressColor !== "",
      ["text-neutral-20"]: this.addressColor === ""
    })}"
    >
      ${sliceAddress(this.address, this.sliceBy, this.sliceBy)}
    </div>`;
  }
  render() {
    const template = (() => {
      if (this.name && this.address) {
        return x`${this.nameTemplate()}${this.addressBytesTemplate()}`;
      }
      if (this.name) {
        return this.nameTemplate();
      }
      if (this.address) {
        return this.addressTemplate();
      }
    })();
    return x`<div
      class="inline-flex ${customClassMap({
      "paragraph-ptmono-12-bold": this.size === "small",
      "paragraph-ptmono-16-bold": this.size === "large"
    })}"
    >
      ${template}
    </div>`;
  }
};
__decorateClass([
  e({ type: String })
], LuksoUsername.prototype, "name", 2);
__decorateClass([
  e({ type: String })
], LuksoUsername.prototype, "address", 2);
__decorateClass([
  e({ type: Number, attribute: "max-width" })
], LuksoUsername.prototype, "maxWidth", 2);
__decorateClass([
  e({ type: "string" })
], LuksoUsername.prototype, "size", 2);
__decorateClass([
  e({ type: Number, attribute: "slice-by" })
], LuksoUsername.prototype, "sliceBy", 2);
__decorateClass([
  e({ type: String, attribute: "address-color" })
], LuksoUsername.prototype, "addressColor", 2);
LuksoUsername = __decorateClass([
  e$1("lukso-username")
], LuksoUsername);

export { LuksoUsername };
